// Linked NC-file list caps at ~10 rows then scrolls, so a job with many files can't push the popup off-screen.
export const MAX_VISIBLE_NC_FILES = 10;
export const NC_FILE_LIST_MAX_HEIGHT = 400;
